import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { Role, Module } from '../../../pages/users/user.model';
import { UsersService } from '../../../pages/users/users.service';

@Component({
  selector: 'app-multi-select-modules',
  templateUrl: './multi-select-modules.component.html',
  styleUrls: ['./multi-select-modules.component.scss'],
  providers: [ UsersService ]
})
export class MultiSelectModulesComponent implements OnInit {
  public modules: Module[];
  public modulesId = new FormControl();
  @Output() public onChangeModule: EventEmitter<any> = new EventEmitter<any>();

  constructor(private usersService: UsersService) {

  }

  ngOnInit() {
    this.usersService.getModules().subscribe(modules => {
      this.modules = modules;
    });
  }

  getNameModule(moduleId){
    return this.modules.find(x => x.id == moduleId).name;
  }

  onChange() {
    this.onChangeModule.emit();
  }

}
